import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import SidePanel from 'fuse-ui/components/SidePanel';
import { withStyles } from '@material-ui/core/styles';

import CanvasSettingsContentTabs from '../canvas-settings/canvas-settings-content-tabs';
import CanvasSettingsContentContainer from '../canvas-settings/canvas-settings-content-container';

import ClaimedDomainDetailsContentTabs from '../domain-details/claimed-domain-details-content-tabs';
import ClaimedDomainDetailsContentContainer from '../domain-details/claimed-domain-details-content-container';

import DomainDetailsContentTabs from '../domain-details/domain-details-content-tabs';
import DomainDetailsContentContainer from '../domain-details/domain-details-content-container';

import SenderDetailsContentTabs from '../sender-details/sender-details-content-tabs';
import SenderDetailsContentContainer from '../sender-details/sender-details-content-container';

import DomainManagementBulkContainer from '../system/domain-management/manage-in-bulk/domain-management-bulk-container';

import UnverifiedSenderDetailsContent from '../unverified-sender-details/unverified-sender-details-content';

import { RIGHT_PANE_VARIANTS } from './constants';
import { RIGHT_PANE_WIDTH } from '../common/constants/ui-options';

const styles  = theme => ( {
    closedDrawer: {
        display: 'none'
    },
    drawer: {
        flexShrink: 0,
    },
    drawerPaper: {
        boxShadow: theme.shadows[4],
        display: 'block',
        overflowX: 'hidden',
        width: RIGHT_PANE_WIDTH,
    },
    editModeDrawerPaper: {
        marginTop: `${theme.spacing.unit * 17}px !important`
    },
    standardDrawerPaper: {
        paddingTop: theme.mixins.toolbar.minHeight + theme.spacing.unit * 2,
    },
} );

export class RightPane extends Component{
    state = {
        tabIndex: 0
    }

    handleTabChange = ( _, tabIndex ) => {
        this.setState( { tabIndex } );
    };

    render(){
        const { tabIndex } = this.state;
        const {
            activePane,
            automationId,
            classes,
            handleClosePane,
            isEditMode,
            subtitle,
            title,
            variant
        } = this.props;

        const isOpen = activePane !== null;

        const headerMap = {
            canvasSettings: CanvasSettingsContentTabs,
            claimedDomainDetails: ClaimedDomainDetailsContentTabs,
            domainDetails: DomainDetailsContentTabs,
            senderDetails: SenderDetailsContentTabs,
        };
        const contentMap = {
            canvasSettings: CanvasSettingsContentContainer,
            claimedDomainDetails: ClaimedDomainDetailsContentContainer,
            domainDetails: DomainDetailsContentContainer,
            domainManagementBulk: DomainManagementBulkContainer,
            senderDetails: SenderDetailsContentContainer,
            unverifiedSenderDetails: UnverifiedSenderDetailsContent
        };

        const RightPaneHeader = headerMap[activePane];
        const RightPaneContent = contentMap[activePane];

        return (
            <SidePanel
                className={cx(
                    classes.drawer,
                    { [classes.closedDrawer]: !isOpen }
                )}
                classes={{
                    drawerPaper: cx(
                        classes.drawerPaper,
                        {
                            [classes.editModeDrawerPaper]: isEditMode,
                            [classes.standardDrawerPaper]: variant === RIGHT_PANE_VARIANTS['standard']
                        }
                    )
                }}
                closeIcon={variant === RIGHT_PANE_VARIANTS['standard']}
                contentHeaderSection={
                    activePane &&
                    RightPaneHeader &&
                    <RightPaneHeader handleTabChange={this.handleTabChange} tabIndex={tabIndex} />
                }
                data-automation-id={automationId}
                title={title}
                subtitle={subtitle}
                open={isOpen}
                onClose={handleClosePane}
                variant={variant}
            >
                {
                    activePane &&
                    <RightPaneContent tabIndex={tabIndex} />
                }
            </SidePanel>
        );
    }

};

RightPane.propTypes = {
    activePane: PropTypes.string,
    automationId: PropTypes.string,
    classes: PropTypes.object,
    handleClosePane: PropTypes.func.isRequired,
    isEditMode: PropTypes.bool.isRequired,
    subtitle: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    variant: PropTypes.string.isRequired
};

export default withStyles( styles )( RightPane );
